import axios from 'axios';

const api = process.env.REACT_APP_BANKVERIFY_URL;
const baseurl = process.env.REACT_APP_BANKVERIFY_URL;

export const VendorBankAccNumberVerify = async (
  ifsc_code,
  account_number,
  setIsLoading,
  handleAlertOpen,
  setFieldValue,
  setIsBankVerified
) => {
  try {
    setIsLoading(true);
    await axios
      .post(
        `${api}/idfy-bank-verification/bank/verify_bank`,
        {
          ifsc_code,
          account_number,
          task_id: sessionStorage.getItem('user_code') ? sessionStorage.getItem('user_code') : 'finvesta',
          group_id: sessionStorage.getItem('user_code') ? sessionStorage.getItem('user_code') : 'finvesta'
        },
        {
          headers: {
                    Authorization:`Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        setIsLoading(false);
        const request_id = res.data.details.request_id;
        if (request_id) {
          sessionStorage.setItem('request_id', request_id);

          VendorVerifyBank_Request_id(ifsc_code, account_number, setIsLoading, handleAlertOpen, 0, setFieldValue, setIsBankVerified);
          // handleClick();
          // sessionStorage.setItem("")
        }
      });
  } catch (error) {
    setIsLoading(false);
    handleAlertOpen(error && error.response && error.response.data.error ? error.response.data.error : 'Something went wrong', 'error');
  }
};

export const VendorVerifyBank_Request_id = async (
  ifsc_code,
  account_number,
  setIsLoading,
  handleAlertOpen,
  instance,
  setFieldValue,
  setIsBankVerified
) => {
  const request_id = sessionStorage.getItem('request_id');
  let retry = instance;
  try {
    setIsLoading(true);
    await axios
      .post(
        `${api}/idfy-bank-verification/bank/task_details`,
        { request_id },
        {
          headers: {
                    Authorization:`Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        setIsLoading(false);
        if (res.data.details.result.status === 'id_found') {
          // const bankname = res.data.details.result.name_at_bank;
          handleAlertOpen('Account verified successfully', 'success');
          setFieldValue('banc_ac_name', res.data.details.result.name_at_bank);
          setIsBankVerified(true);
        }
      });
  } catch (error) {
    if (retry < 4) {
      setTimeout(() => {
        VendorVerifyBank_Request_id(ifsc_code, account_number, setIsLoading, handleAlertOpen, retry + 1, setFieldValue, setIsBankVerified);
      }, 2000);
    } else {
      setIsLoading(false);
      console.log('error', error);
      handleAlertOpen(error && error.response && error.response.data.error ? error.response.data.error : 'Something went wrong', 'error');
    }
  }
};

export const HandlePanVerify = async (pan_number, name, dob, setIsLoading, handleAlertOpen, setIsPanVerified) => {
  try {
    setIsLoading(true);
    await axios
      .post(`${api}/aadhar-idfy/pancard`, {
        pan_number: pan_number,
        full_name: name,
        dob: dob
      })
      .then((res) => {
        setIsLoading(false);
        if (res.status === 200) {
          const pan_string = res.data.pan_status;
          const splitFn = pan_string.split('.');
          if (splitFn[0] === 'Existing and Valid'&&res.data.dob_match&&res.data.name_match) {
            handleAlertOpen('Pan verified successfully', 'success');
            setIsPanVerified(true);
          } else {
            handleAlertOpen('Pan not found or invalid details provided', 'error');
          }
        }
      });
  } catch (error) {
    setIsLoading(false);
    handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong', 'error');
  }
};

export const PostEditData = async (item, PostEditData, setIsLoading, handleClose, handleAlertOpen, handleSearch) => {
  const data = {};
  data['_id'] = item._id;
  if (PostEditData.mobile_number && PostEditData.mobile_number !== '') {
    data['mobile_number'] = PostEditData.mobile_number;
  }
  if (PostEditData.email_address && PostEditData.email_address !== '') {
    data['email_address'] = PostEditData.email_address;
  }
  if (PostEditData.address && PostEditData.address !== '') {
    data['address'] = PostEditData.address;
  }
  try {
    setIsLoading(true);
    await axios
      .post(`${api}/procurement/vendor/request/basic_edit`, data, {
        headers: {
                  Authorization:`Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then((res) => {
        setIsLoading(false);
        handleAlertOpen(res.data.message, 'success');
        handleClose();
        handleSearch();
      });
  } catch (error) {
    setIsLoading(false);
    handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong', 'error');
  }
};

export const HandleSubmitVendorDetails = async (postData, FileData, setIsLoading, handleAlertOpen) => {
  console.log(FileData);

  try {
    setIsLoading(true);
    const formData = new FormData();
    formData.append('vendor_name', postData['vendor_name']);
    formData.append('company_name', postData['company_name']);
    formData.append('pan_card_no', postData['pan_number']);
    formData.append('mobile_number', postData['mobile_number']);
    formData.append('mobile_number_2', postData['alternate_number']);
    formData.append('email_address', postData['email_address']);
    formData.append('address', postData['address']);
    formData.append('pin_code', postData['pincode']);
    formData.append('district', postData['district']);
    formData.append('sub_district', postData['sub_district']);
    formData.append('city_name', postData['city_or_town']);
    formData.append('gst_number', postData['gst_number']);
    formData.append('bank_account_number', postData['current_account_number']);
    formData.append('bank_account_name', postData['banc_ac_name']);
    formData.append('bank_name', postData['bank_name']);
    formData.append('ifsc_code', postData['ifsc_code']);
    formData.append('dob', postData['dob']);
    for (let key in FileData) {
      formData.append(key, FileData[key]);
    }
    await axios
      .post(`${baseurl}procurement/vendor/add`, formData, {
        headers: {
                  Authorization:`Bearer ${sessionStorage.getItem('token')}`,
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => {
        setIsLoading(false);
        if (res.status === 201) {
          handleAlertOpen(res.data.message, 'success');
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong', 'error');
      });
  } catch (error) {
    setIsLoading(false);
    handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong', 'error');
  }
};
